window.middysHawkSearchTemplates = window.middysHawkSearchTemplates || {};
window.middysHawkSearchTemplates.unifiedSearchField = `
    <style>
        .search-field {
            position: relative;
        }

        input[type="submit"] {
            position: absolute;
            top: 0;
            left: 5px;
            height: 100%;
            width: 40px;
            border: 0;
            background: url(/images/search-icon.svg) no-repeat center / 20px;
            cursor: pointer;
        }

        input[type="text"] {
            font-size: 14px;
            line-height: 20px;
            width: 100%;
            padding: 7px 36px 7px 40px;
            border-radius: 0;
            transition: all .3s ease-in-out;
            height: 38px;
        }

        .search-clear {
            position: absolute;
            top: 50%;
            right: 8px;
            transform: translateY(-50%);
            width: 20px;
            height: 20px;
            padding: 0;
            border: 0;
            background: none;
            cursor: pointer;
            font-size: 16px;
            line-height: 1;
            color: #999;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .search-clear:hover {
            color: #e6007e;
        }

        input[type="text"]:placeholder-shown ~ .search-clear {
            display: none;
        }

        @media screen and (max-width: 991px), print {
            input[type=search], input[type=text] {
                padding: 8px 36px 8px 40px;
            }
        }

        :host, :root {
            --default-line-height: clamp(24px, 1.4vw, 29px);
            --default-font-color: #666;
            --default-font-color--inverse: '';
            --default-font-family: 'Open Sans', sans-serif;
            --default-font-size: clamp(14px, 1.4vw, 16px);;
            --padding-xs: '20';
            --form-element-border:'1px solid #f4f4f4';
            --color-accent:'';
            font-family: 'Open Sans', sans-serif;
            font-size: clamp(14px, 1.4vw, 16px);
            color: #666;
            line-height: clamp(24px, 1.4vw, 29px);
        }
    </style>
    <form class="search-field" action="/smartsearch" method="get">
        <input type="text" hawksearch-input hawksearch-unified-search name="keyword" value="{{query}}" enterkeyhint="search" inputmode="search" placeholder="What can we help you find today?" />
        <button type="button" class="search-clear">&#x2715;</button>
        <input type="submit" id="head-submit" value="" />
        <hawksearch-autocomplete request-type="UnifiedSearch"></hawksearch-autocomplete>
    </form>
`;
